import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { createContextForController } from 'react-controller-context';
import { ILinkedTask, IMember } from 'types';
import { useQueryClient } from '@tanstack/react-query';

export interface GlobalSearchContext {
  searchType: string;
  currentMemberId?: number;
  currentTaskId?: string;
  setSearchType: (s: string) => void;
  handleMemberSelect: (event: any) => void;
  handleTaskSelect: (event: any) => void;
}

export const useGlobalSearch = (): GlobalSearchContext => {
  const location = useLocation();
  const [searchType, setSearchType] = useState<string>('member');
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const memberId = location?.state?.paramsData?.memberId;
  const taskId = location?.state?.paramsData?.taskId;

  const clearCache = () => {
    if (memberId) {
      queryClient.removeQueries({ queryKey: ['Member', memberId] });
    }
    if (taskId) {
      queryClient.removeQueries({ queryKey: ['MemberTask', taskId] });
    }
  };

  const handleMemberSelect = (event: any) => {
    const selectedMember = event.target.value as IMember;
    if (selectedMember.memberId !== memberId) {
      navigate('/member', {
        state: {
          paramsData: {
            memberId: selectedMember.memberId
          }
        }
      });
      clearCache();
    }
  };

  const handleTaskSelect = (event: any) => {
    const selectedTask = event.target.value as ILinkedTask;
    if (selectedTask.taskId !== taskId) {
      navigate(`/task`, {
        state: {
          paramsData: {
            taskId: selectedTask.taskId
          }
        }
      });
      clearCache();
    }
  };

  return {
    searchType,
    currentMemberId: memberId,
    currentTaskId: taskId,
    setSearchType,
    handleMemberSelect,
    handleTaskSelect
  };
};

const globalSearchContext = createContextForController(useGlobalSearch);

export default globalSearchContext;
